/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HorizontalStatusPageNavEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const horizontalStatusPageNavEntrypoint: EntryPoint<
	HorizontalStatusPageNavEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<HorizontalStatusPageNavEntrypointComponent>(
		/* webpackChunkName: "async-horizontal-status-page-nav" */ './ui/HorizontalStatusPageNav.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
